// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ai-conformity-assessment-ce.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ai-conformity-assessment-ce',
  title: 'Conformity assessment, EU declaration, CE marking and registration for high-risk AI',
  description:
    'Confirm that providers of high-risk AI systems subject each such system to the applicable conformity-assessment procedure (EU AI Act Art. 43), draw up an EU declaration of conformity (Art. 47), affix the CE marking (Art. 48) and register the system in the EU database for high-risk AI (Art. 49, 71) before placing it on the market or putting it into service. Records supporting conformity (including references to harmonised standards under Art. 40 and common specifications under Art. 41) shall be retained for the period required by the Regulation. Review the conformity-assessment standard, the register of CE-marked systems, and the latest EU declarations of conformity.',
  category: 'compliance',
  scfIds: ['SCF-AIG-015'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Conformity-assessment standard is published' },
    { type: 'document-approved', description: 'Standard has been approved' },
    { type: 'document-within-sla', description: 'Standard review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
